import api from 'app/AxiosInstance'
import { useQuery } from 'react-query'

const useAccounts = () => {
  //$ ================================================================================ $//
  //$                                GET ALL ACCOUNTS
  //$ ================================================================================ $//

  const { data: accounts, isLoading: isLoadingAccounts } = useQuery({
    queryKey: ['getAllAccounts'],
    queryFn: async () => {
      const { data } = await api.get('/accounts')

      return data.data
    },
  })

  return { accounts, isLoadingAccounts }
}

export default useAccounts
